import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON_CONVERSION,
  PAYOFF_COUPON_FREQUENCY,
  PAYOFF_COUPON_REFERENCE_RATE,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_FLOOR_STRIKE,
  PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
  PAYOFF_PARTICIPATION_STRIKE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
  SUMMARY_FREQUENCY,
  PAYOFF_CALLABILITY_BARRIER_TYPE,
  PAYOFF_CALLABILITY_AMOUNT_TYPE,
  PAYOFF_CALLABILITY_AMOUNT,
  PAYOFF_CALLABILITY_FREQUENCY,
  PAYOFF_CALLABILITY_TOUCH_BREAK,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { BARRIER_AMOUNT_WITH_CUSTOM } from 'src/app/product-capture/model/consts/barrier-amout.const';
import { DEFAULT_AND_SHOW_CAPITAL_BASE_VALUES } from './cln.settings';

export const AUTOCALL_SETTINGS = {
  id: ProductTypeEnum.AUTOCALL,
  label: 'Autocallable',
  effects: [
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: [COUPON_TYPE.FIXED],
      hidden: false,
      readOnly: false,
    },
    ...DEFAULT_AND_SHOW_CAPITAL_BASE_VALUES,
    {
      formControlNames: [
        PAYOFF_COUPON_REFERENCE_RATE,
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON_CONVERSION,
      ],
      hidden: true,
    },
    {
      formControlNames: [
        SUMMARY_UNDERLYING_ASSETS_GROUP,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
        PAYOFF_PARTICIPATION_FLOOR_STRIKE,
      ],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_FREQUENCY],
      readOnly: false,
    },
    {
      formControlNames: [
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_BASE_TYPE,
      ],
      selectValues: ['NONE'],
      hidden: true,
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_FREQUENCY],
      selectValues: ['1Y'],
      hidden: true,
    },

    {
      formControlNames: [
        PAYOFF_CALLABILITY_BARRIER_TYPE,
        PAYOFF_CALLABILITY_AMOUNT_TYPE,
      ],
      selectValues: ['FLAT'],
      hidden: false,
    },

    {
      formControlNames: [PAYOFF_CALLABILITY_TOUCH_BREAK],
      selectValues: [true],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_TYPE],
      selectValues: ['PUT'],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
      selectValues: ['AUTOCALL'],
      readOnly: true,
    },

    {
      formControlNames: [PAYOFF_CALLABILITY_AMOUNT],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: '100%',
          indicativeValue: null,
        },
      ],
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE],
      readOnly: false,
    },
    {
      formControlNames: [SUMMARY_FREQUENCY, SUMMARY_SETTLEMENT_TYPE],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_STRIKE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_BARRIER_TYPE],
      options: [...BARRIER_AMOUNT_WITH_CUSTOM],
      hidden: false,
    },
  ],
};
